module.exports = __webpack_public_path__ + "static/stone_giant-579fd411fbf7037fc465bf6459092c37.jpg";